import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Button from '@/common/components/atoms/Button/Button';
import Snack from '@/common/components/molecules/Snack/Snack';
import { ROUTE_CARTS } from '@/common/constants';
import { useTagManager } from '@/common/contexts/TagManagerContext';
import postCart from '@/ebat/api/carts/postCart';
import {
  NewCartButtonDefaultProps,
  NewCartButtonPropTypes,
} from '@/ebat/components/blocks/Header/CartButton/NewCartButton/NewCartButton.proptypes';
import { TAG_MANAGER } from '@/ebat/constants';

const NewCartButton = ({ className, children }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { onPushEvent } = useTagManager();
  const { mutate, isLoading } = useMutation(postCart);
  const createCart = () => {
    mutate(
      {
        name: 'Nouveau panier #1',
      },
      {
        onSuccess: (data) => {
          const { id } = data;
          onPushEvent({ event: TAG_MANAGER.EVENTS.CTA_ADD_CART });
          history.push(`${ROUTE_CARTS}/${id}`);
        },
        onError: (error) => {
          if (error.response.status === 500) {
            toast.error(
              <Snack
                message={t('common:messages:forms.errors.server_error')}
              />,
            );
          } else {
            toast.error(
              <Snack message={t('common:messages:forms.errors.default')} />,
            );
          }
        },
      },
    );
  };

  return (
    <Button
      className={className}
      context="header-add-to-cart"
      disabled={isLoading}
      onClick={createCart}
    >
      {children}
    </Button>
  );
};

NewCartButton.defaultProps = {
  ...NewCartButtonDefaultProps,
};

NewCartButton.propTypes = {
  ...NewCartButtonPropTypes,
};

export default NewCartButton;
